import React, { useState } from "react";
import Loading from "./Loading";
import { usePlayerStats, MedalGrid, MedalGridFooter } from "./ProfileStats";
import { t } from "../i18n";
import PageHead from "./PageHead";

// « Toutes les médailles », en plein écran : la même grille que l'onglet du
// profil (recherche, sélection pour l'encadré), juste plus grande — la
// sélection change ici comme là-bas, c'est le même compte.
function MedalsPage({ account, onExpired, onBack }) {
  const { stats, error } = usePlayerStats(account, onExpired);
  const [query, setQuery] = useState("");
  const [equippedMedals, setEquippedMedals] = useState(null);

  const head = <PageHead onBack={onBack} title={t("medals.pageTitle")} />;

  if (error) return <>{head}<div class="MedalsPage"><p class="auth-error">{error}</p></div></>;
  if (!stats) return <>{head}<div class="MedalsPage"><Loading label={t("stats.loading")} /></div></>;

  const medalIds = equippedMedals || stats.equippedMedals || [];
  const toggleMedal = async (id) => {
    const has = medalIds.includes(id);
    if (!has && medalIds.length >= 5) return;
    const prev = medalIds;
    const next = has ? medalIds.filter(x => x !== id) : [...medalIds, id];
    setEquippedMedals(next);
    try {
      const API = process.env.REACT_APP_API_URL || "";
      const r = await fetch(`${API}/auth/me/medals/equip`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${account.token}` },
        body: JSON.stringify({ ids: next }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error();
      setEquippedMedals(d.equippedMedals || next);
    } catch (_) {
      setEquippedMedals(prev);
    }
  };

  return (
    <>
    {head}
    <div class="MedalsPage">
      <p class="medal-pick-hint">{t("medals.pickHint")}</p>
      <div class="medal-page-body">
        <MedalGrid medals={stats.medals || []} query={query} equippedIds={medalIds} onToggleEquip={toggleMedal} badgeSize={84} />
      </div>
      <MedalGridFooter query={query} onQuery={setQuery} />
    </div>
    </>
  );
}

export default MedalsPage;
